import { nanoid } from 'nanoid';

// HEAD DATA
export const headData = {
  title: 'Chris Paulusson | Portfolio', // e.g: 'Name | Developer'
  lang: 'en', // e.g: en, es, fr, jp
  description: 'Welcome to my portfolio', // e.g: Welcome to my website
};

// HERO DATA
export const heroData = {
  name: '',
  cta: 'Know more',
};

// ABOUT DATA
export const aboutData = {
  img: 'profile.jpg',
  paragraphOne: 'My name is Chris (Christoffer) Paulusson, and I am a 24-year-old university student with a passion for technology. I am currently on my last year of the Master of Science program in Media Technology and Engineering at Linköping University in Sweden. This program focuses on programming, web development, computer graphics, information visualization, AR/VR, and AI as well as the standard engineering courses. The reason why I chose Media Technology was that it allows me to combine creativity with technology and problem-solving.',
  paragraphTwo: 'During my free time, I like to work out, hang out with my friends, and hit the skatepark with my board when the weather is nice! A newer hobby of mine is photography and editing photos (still beginner)!',
  paragraphThree: 'I created this website to have a place where I can display some of my projects from my years at university. If you want to contact me, you can find more info in the Contact section!',
  resume: '', // if no resume, the button will not show up
};

// PROJECTS DATA
export const projectsData = [

  {
    id: nanoid(),
    img: 'scene64.png',
    title: 'Monte Carlo Ray Tracer',
    info: 'A Whitted ray tracer with Monte Carlo integration implemented from scratch in C++. The scene contains perfect reflectors (mirrors), diffuse (Lambertian and Oren Nayar), and transparent surfaces. Monte Carlo ray tracing is known to be slow and noisy, yet it gives good results. To achieve Anti-aliasing, supersampling and ray-randomization was combined, which produced more noise but is less disturbing to the viewer. The more samples used, the less noisy the image appeared.',
    info2: 'Course: TNCG15 - Advanced Global Illumination and Rendering',
    url: '',
    repo: 'https://github.com/morenadam/Monto-Carlo-Ray-Tracer', // if no repo, the button will not show up
    course: '',
    report: 'carlos.pdf',
  },
  {
    id: nanoid(),
    img: 'particles.png',
    title: 'Particle System with Collisions',
    info: 'A Simulation of a particle system with collision handling and physical forces using the Euler method. The Euler method is a first-order method, which means the error-per-step is proportional to the square of the step size. You can clearly see the error when looking at the particles rolling on the triangle-plane in this project. The particles spawn from a fountain with a random upwards-velocity, interact with the other objects in the scene, and despawn after 7 seconds. I wrote this project in JavaScript with Three.js, which is an API that uses WebGL to display 3D computer graphics in the browser. To see the project in your browser, click the "See Live" button below!',
    info2: 'Course: CA - Computer Animation (at UPC in Barcelona)',
    url: 'https://chrpa821.github.io/particle-system',
    repo: 'https://github.com/chrpa821/particle-system',
    course: '',
    report: '',
  },
  {
    id: nanoid(),
    img: 'webshop.png',
    title: 'Webshop',
    info: 'Fullstack web project using the MERN stack (MongoDb, Express, React, Node) with Redux for state management and Cloudinary for storing images. In the application, it is possible to create products (if the user is logged in), show products, search products, register users, log in/out (protected pages are only accessible to logged-in users), and add products to the shopping cart. To see the project screencast, click the "See Live" button below!',
    info2: 'Course: TDDD27 - Advanced Web Programming ',
    url: 'https://www.youtube.com/watch?v=CpGbj2rv2j0&feature=youtu.be',
    repo: 'https://github.com/hannahbergenroth/Webshop', // if no repo, the button will not show up
    course: '',
    report: '',
  },
  {
    id: nanoid(),
    img: 'cardBoardVR.png',
    title: 'Infinite Runner for Google Cardboard (VR)',
    info: 'A simple VR game implemented in Unity for Google CardBoard. The goal of this project was to develop a game that was easily playable without many buttons or haptics. Our solution was to create an infinite runner; this way, the player is continually moving. The player has to choose which lane to ride on while avoiding the stalagmites while collecting crystals to get as many points as possible. You can duck if you drop your head and you can push the lever on the right to use the break.',
    info2: 'Course: VAR - Virtual and Augmented Reality (at UPC in Barcelona)',
    url: '',
    repo: 'https://github.com/rurush47/var-vr', // if no repo, the button will not show up
    course: '',
    report: '',
  },
];

// CONTACT DATA
export const contactData = {
  cta: '',
  btn: '',
  email: 'chrispaulusson@gmail.com',
};

// FOOTER DATA
export const footerData = {
  networks: [
    {
      id: nanoid(),
      name: 'facebook',
      url: 'https://www.facebook.com/chris.paulusson/',
    },
    {
      id: nanoid(),
      name: 'linkedin',
      url: 'https://www.linkedin.com/in/chrispaulusson/',
    },
    {
      id: nanoid(),
      name: 'github',
      url: 'https://github.com/chrpa821',
    },
  ],
};
